const common = require("lib/labels/_common");

// Home.backoffice.users

module.exports = {
  userList: {
    title: common.users,
    title_delete_check: common.title_delete_check,
    content_delete_check: common.content_delete_check,
    no: common.no,
    yes: common.yes,
    online: {
      en: "Online",
      fr: "En ligne"
    },
    offline: {
      en: "Offline",
      fr: "Hors ligne"
    },
    edit: common.edit,
    remove: common.remove,
    email: common.email,
    detailed: {
      type: {
        en: "Type",
        fr: "Type"
      },
      group: {
        en: "Group",
        fr: "Groupe"
      },
      profile: common.profile,
      projects: common.projects,
      firstName: {
        en: "FirstName",
        fr: "Prénom"
      },
      lastName: {
        en: "LastName",
        fr: "Nom"
      },
      email: common.email,
      phone: {
        en: "Phone",
        fr: "Téléphone"
      },
      mobile: {
        en: "Mobile",
        fr: "Mobile"
      }
    }
  },
  userForm: {
    stepTitle: {
      en: "User",
      fr: "Utilisateur"
    },
    title: {
      edition: {
        en: "User edition",
        fr: "Edition d'utilisateur"
      },
      creation: {
        en: "User Creation",
        fr: "Création d'utilisateur'"
      }
    },
    pseudo: {
      label: common.pseudo,
      text: {
        en: "Give a user pseudo",
        fr: "Donnez un peudo à l'utilisateur"
      }
    },
    profile: {
      label: common.profile,
      text: {
        en: "Set a user profile",
        fr: "Donnez un profil à l'utilisateur"
      }
    },
    group: {
      label: {
        en: "group",
        fr: "Groupe"
      },
      text: {
        en: "Set an group",
        fr: "Sélectionnez le groupe de l'utilisateur"
      }
    }
  }
};
